import React, { useState } from 'react';
import EventCardDateHeader from '@atoms/CardDateHeader/EventCardDateHeader';
import EventCardLocation from '@atoms/CardLocation/EventCardLocation';
import EventCardDateTime from '@atoms/CardDateTime/EventCardDateTime';
import EventCardHeading from '@atoms/CardHeading/EventCardHeading';
import EventCardSave from '@atoms/CardSave/EventCardSave';
import EventCardImage from '@atoms/CardImage/EventCardImage';

const CardEvents = ({ data }) => {
  const [display, setDisplay] = useState(true);

  const saveProps = {
    data: data,
    setDisplay: setDisplay,
  };

  return display ? (
    <li className="js-card event-cards__card base-cards__card--link">
      <div className="event-cards__body" key={`card-${data?.id}`}>
        <EventCardDateHeader {...data} />
        <EventCardHeading {...data} />
        <ul className="card-summary">
          <EventCardDateTime {...data} />
          <EventCardLocation {...data} />
          <EventCardSave {...saveProps} />
        </ul>
      </div>
      <EventCardImage {...data} />
    </li>
  ) : null;
};

export default CardEvents;
